import axios from 'axios';

const memberCenterService = {
  fetchUserCredits: (params = { limit: 24, page: 1 }) => {
    return axios.get('/api/user_credits', {
      params,
    });
  },
  fetchMemberPoints: (params = { limit: 24, page: 1 }) => {
    return axios.get('/api/member_points', {
      params,
    });
  },
  fetchMemberPointRules: ({ rule_type } = {}) => {
    return axios.get('/api/member_point_rules', {
      params: { rule_type },
    });
  },
  fetchFulfillmentSummary: (limit) => {
    return axios.get('/api/member_point_fulfillments/summary', {
      params: { limit },
    });
  },
  checkRedeemGiftPromotionExist: () =>
    axios.get('/api/promotions/is_redeem_gift_promotion_exist'),
  checkMemberReward: (userId) =>
    axios.post(`/api/users/${userId}/send_member_info_reward`),
  checkMemberRewardForLINEOrFB: (userId) =>
    axios.get(`/api/users/${userId}/info_reward_eligibility`),
};

export default memberCenterService;
